//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
    name: "index",
    data() {
        return {
            lang: '',
        }
    },
    methods: {
        gotoQA() {
            this.$router.push({
                path: '/activity5G/question'
            })
        },
        gotoPay() {
            this.$router.push({
                path: '/activity5G/pay'
            })
        }
    },
    mounted() {
    },
    created() {
        this.lang = window.localStorage.lang
    }
}



// WEBPACK FOOTER //
// ./src/page/activity5G/index.vue